import { render, staticRenderFns } from "./MoComService.vue?vue&type=template&id=73609204&"
import script from "./MoComService.vue?vue&type=script&lang=js&"
export * from "./MoComService.vue?vue&type=script&lang=js&"
import style0 from "./MoComService.vue?vue&type=style&index=0&id=73609204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports